// extracted by mini-css-extract-plugin
export default {"action-wrapper":"styles_action-wrapper__CSCz3"};